import gql from 'graphql-tag';

const updatePlotEvidenceMutation = gql`
  mutation updatePlotEvidence(
    $id: ID!
    $plotId: ID!
    $folderNumber: Int!
    $orderIndex: Int!
    $requiredActors: Int!
    $evidenceId: ID!
  ) {
    data: updatePlotEvidence(
      id: $id
      plotId: $plotId
      folderNumber: $folderNumber
      orderIndex: $orderIndex
      requiredActors: $requiredActors
      evidenceId: $evidenceId
    ) {
      id
      plotId
      folderNumber
      evidenceId {
        id
        name
      }
      orderIndex
      requiredActors
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const updatePlotEvidence = async ({ client, params }) => {
  params.data.evidenceId = params.data.evidenceId.id;
  const result = await client.mutate({
    mutation: updatePlotEvidenceMutation,
    variables: {
      ...params.data,
    },
  });

  return result.data;
};
